/**
 * Run a callback function after an event hasn't been fired for a specified period of time (ms)
 * @param callback - callback method to be executed after ms delay
 * @param ms - delay in milliseconds
 * @param immediate - whether to run the callback immediately and then wait for the delay to be run again
 */
export default function (func: (...args: any) => void, wait: number, immediate = false) {
  let timeout: NodeJS.Timeout | null

  return function executedFunction(...args: any) {
    // @ts-ignore
    let context = this

    let later = function () {
      timeout = null
      // @ts-ignore
      func.apply(context, args)
    }

    let callNow = immediate && !timeout

    clearTimeout(timeout!)

    timeout = setTimeout(later, wait)

    // @ts-ignore
    if (callNow) func.apply(context, args)
  }
}
